import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import BannerSingle from '../../BannerSingle';
import PageDescription from '../../PageDescription';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';

class Acesso extends Component {

	render() {

		return (
            
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<ErrorBoundary><BannerSingle page={"acesso-informacao"} image={"acesso-informacao"}/></ErrorBoundary>

				{/* Page description */}
				<ErrorBoundary><PageDescription page={"acesso-informacao"} /></ErrorBoundary>
				{/* Content page */}
                {/* <section className="_the-content pb-10">
                    <div className='container'>
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <h3> Como será o procedimento interno? </h3>
                                <p>
                                    A equipe de atendimento tem até cinco dias úteis para consultar a área técnica, caso necessário, e responder o participante. A resposta será encaminhada por meio dos contatos cadastrados na Forluz.
                                </p>

                                <p>
                                    Caso o pedido seja negado pela área técnica ou se o envio de uma solução extrapolar o prazo legal de 30 dias, o participante poderá entrar com recurso junto à Diretoria Executiva. Se o recurso for negado pela Diretoria, é possível apresentar o recurso ao Conselho Deliberativo. Este recurso deverá ser enviado por e-mail, correspondência ou entregue pessoalmente na Fundação. O documento precisa conter: pedido inicial, negativa, contextualização e justificativa/defesa do recurso.
                                </p>

                                <p>
                                    A partir daí, internamente, a Forluz pautará o assunto em reunião. O órgão colegiado receberá também um dossiê que reúne as informações sobre o caso. A resposta do Conselho será emitida em certidão redigida e encaminhada pelo setor de Governança à área técnica. Em seguida, o solicitante receberá este parecer.
                                    <br/>
                                    Caso a Fundação não cumpra o prazo de resposta, o participante pode registrar reclamação junto à PREVIC (Superintendência Nacional de Previdência Complementar). O órgão fiscalizador fornece as seguintes orientações:
                                </p>

                                <p>
                                    "Para denúncia sobre suspeita de infração às disposições legais ou disciplinadoras das entidades fechadas de previdência complementar (EFPC) ou da própria Previc, deve ser formalizado expediente, conforme disposições do art. 38 do Decreto nº 4.942, de 30 de dezembro de 2003, devidamente protocolado na sede da Previc, situada no SCN, Quadra 06, Ed. Venâncio 3000, Conjunto A, 7º andar - Asa Norte - CEP: 70.716-900 - Brasília/DF ou pelo Fala.BR, anexando o expediente contendo os requisitos dispostos no art. 38 do Decreto já citado".

                                    Para mais informações, acesse: <a href="http://www.previc.gov.br" target="_blank"> http://www.previc.gov.br </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </section> */}
				{/*  <ScrollInfinito/> */}
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default Acesso;